import { E as sanitize_props, F as spread_props, G as slot, A as push, J as escape_html, D as pop, O as spread_attributes, P as bind_props, Q as copy_payload, R as assign_payload, S as await_block, I as attr, T as stringify, U as store_get, V as store_mutate, W as ensure_array_like, X as maybe_selected, Y as unsubscribe_stores } from "../../../chunks/index2.js";
import { B as Button } from "../../../chunks/Select.svelte_svelte_type_style_lang.js";
import { g as getLocale, t as trackMessageCall } from "../../../chunks/runtime.js";
import "@sveltejs/kit/internal";
import "../../../chunks/exports.js";
import "../../../chunks/utils.js";
import "../../../chunks/client2.js";
import QRCode from "qrcode";
import { s as sign_in_link, a as sign_out, A as AnchorButton } from "../../../chunks/AnchorButton.js";
import { I as Icon } from "../../../chunks/Icon.js";
import { e as error_empty_key, a as error_invalid_email, b as error_invalid_url, c as error_link_min_lenght, i as invalid_maxvalue1, d as invalid_minvlaue1, f as invalid_number, g as invalid_private_link, h as getTTLs, j as getLinkSchema, v as valibotClient, k as couldTLLInfinit } from "../../../chunks/valibot.js";
import "ts-deepmerge";
import "memoize-weak";
import "zod-to-json-schema";
import { s as superForm } from "../../../chunks/formData.js";
import "@sveltejs/kit";
import { S as SHORTEN_LENGTH } from "../../../chunks/defaults.js";
import { nanoid } from "nanoid";
import { b as about_link, m as meta_description, a as meta_keywords, s as setup_link, t as title } from "../../../chunks/setup_link.js";
import { g as github_link_title, i as imprint, m as made_with_love, t as terms_of_use } from "../../../chunks/imprint.js";
import { e as email, a as email_info, s as send_verification, b as sign_in } from "../../../chunks/send_verification.js";
import { o as original_link1, r as redirect_to, s as secret, a as shrtn_outdated_headline, b as shrtn_outdated_subline, c as shrtn_passphrase_headline, d as shrtn_passphrase_info, e as shrtn_passphrase_subline, f as shrtn_unsecure_headline, g as shrtn_unsecure_subline } from "../../../chunks/secret.js";
import { s as send_again, a as send_failed, b as sending, v as verification_headline, c as verification_subline, d as verify } from "../../../chunks/verify.js";
import { v as verification, a as verification_mail_body, b as verification_mail_headline } from "../../../chunks/verification_mail_body.js";
import { i as invalid_email_not_allowed } from "../../../chunks/invalid_email_not_allowed.js";
import { s as shrtn_passphrase_invalid } from "../../../chunks/shrtn_passphrase_invalid.js";
import { u as unsecure_link } from "../../../chunks/unsecure_link.js";
import { I as InputFrame } from "../../../chunks/InputFrame.js";
import "clsx";
import { I as Input } from "../../../chunks/Input.js";
const en_teaser = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `A small easy to setup open-source link shortener`;
  }
);
const de_teaser = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Kürze deine Links einfach und schnell mit Open-Source-Software und auf Wunsch mit eigener Domain`;
  }
);
const sp_teaser = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Acorta tus enlaces fácil y rápidamente con software de código abierto`;
  }
);
const teaser = /* @__NO_SIDE_EFFECTS__ */ (inputs = {}, options = {}) => {
  const locale = options.locale ?? getLocale();
  trackMessageCall("teaser", locale);
  if (locale === "en") return en_teaser();
  if (locale === "de") return de_teaser();
  return sp_teaser();
};
const en_teaser_sub = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `host your own`;
  }
);
const de_teaser_sub = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `setze einfach Deine eigene Instanz auf`;
  }
);
const sp_teaser_sub = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `gestiona el tuyo`;
  }
);
const teaser_sub = /* @__NO_SIDE_EFFECTS__ */ (inputs = {}, options = {}) => {
  const locale = options.locale ?? getLocale();
  trackMessageCall("teaser_sub", locale);
  if (locale === "en") return en_teaser_sub();
  if (locale === "de") return de_teaser_sub();
  return sp_teaser_sub();
};
const en_link1 = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Link`;
  }
);
const de_link1 = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Link`;
  }
);
const sp_link1 = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Link`;
  }
);
const link1 = /* @__NO_SIDE_EFFECTS__ */ (inputs = {}, options = {}) => {
  const locale = options.locale ?? getLocale();
  trackMessageCall("link1", locale);
  if (locale === "en") return en_link1();
  if (locale === "de") return de_link1();
  return sp_link1();
};
const en_link_input_placeholder = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `https://example.com`;
  }
);
const de_link_input_placeholder = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `https://example.de`;
  }
);
const sp_link_input_placeholder = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `https://example.com`;
  }
);
const link_input_placeholder = /* @__NO_SIDE_EFFECTS__ */ (inputs = {}, options = {}) => {
  const locale = options.locale ?? getLocale();
  trackMessageCall("link_input_placeholder", locale);
  if (locale === "en") return en_link_input_placeholder();
  if (locale === "de") return de_link_input_placeholder();
  return sp_link_input_placeholder();
};
const en_link_input_description = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Enter your link in the input field and choose a time to live`;
  }
);
const de_link_input_description = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Füge deinen Link in das Eingabefeld ein und wähle eine Gültigkeitsdauer`;
  }
);
const sp_link_input_description = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Introduce tu enlace en el campo y elige un tiempo de vida`;
  }
);
const link_input_description = /* @__NO_SIDE_EFFECTS__ */ (inputs = {}, options = {}) => {
  const locale = options.locale ?? getLocale();
  trackMessageCall("link_input_description", locale);
  if (locale === "en") return en_link_input_description();
  if (locale === "de") return de_link_input_description();
  return sp_link_input_description();
};
const en_anhour = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `an hour`;
  }
);
const de_anhour = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `eine Stunde`;
  }
);
const sp_anhour = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `una hora`;
  }
);
const anhour = /* @__NO_SIDE_EFFECTS__ */ (inputs = {}, options = {}) => {
  const locale = options.locale ?? getLocale();
  trackMessageCall("anhour", locale);
  if (locale === "en") return en_anhour();
  if (locale === "de") return de_anhour();
  return sp_anhour();
};
const en_aday = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `a day`;
  }
);
const de_aday = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `ein Tag`;
  }
);
const sp_aday = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `un día`;
  }
);
const aday = /* @__NO_SIDE_EFFECTS__ */ (inputs = {}, options = {}) => {
  const locale = options.locale ?? getLocale();
  trackMessageCall("aday", locale);
  if (locale === "en") return en_aday();
  if (locale === "de") return de_aday();
  return sp_aday();
};
const en_aweek = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `a week`;
  }
);
const de_aweek = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `eine Woche`;
  }
);
const sp_aweek = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `una semana`;
  }
);
const aweek = /* @__NO_SIDE_EFFECTS__ */ (inputs = {}, options = {}) => {
  const locale = options.locale ?? getLocale();
  trackMessageCall("aweek", locale);
  if (locale === "en") return en_aweek();
  if (locale === "de") return de_aweek();
  return sp_aweek();
};
const en_amonth = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `a month`;
  }
);
const de_amonth = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `ein Monat`;
  }
);
const sp_amonth = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `un mes`;
  }
);
const amonth = /* @__NO_SIDE_EFFECTS__ */ (inputs = {}, options = {}) => {
  const locale = options.locale ?? getLocale();
  trackMessageCall("amonth", locale);
  if (locale === "en") return en_amonth();
  if (locale === "de") return de_amonth();
  return sp_amonth();
};
const en_ayear = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `a year`;
  }
);
const de_ayear = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `ein Jahr`;
  }
);
const sp_ayear = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `un año`;
  }
);
const ayear = /* @__NO_SIDE_EFFECTS__ */ (inputs = {}, options = {}) => {
  const locale = options.locale ?? getLocale();
  trackMessageCall("ayear", locale);
  if (locale === "en") return en_ayear();
  if (locale === "de") return de_ayear();
  return sp_ayear();
};
const en_forever = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `forever`;
  }
);
const de_forever = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `für immer`;
  }
);
const sp_forever = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `para siempre`;
  }
);
const forever = /* @__NO_SIDE_EFFECTS__ */ (inputs = {}, options = {}) => {
  const locale = options.locale ?? getLocale();
  trackMessageCall("forever", locale);
  if (locale === "en") return en_forever();
  if (locale === "de") return de_forever();
  return sp_forever();
};
const en_expires_in = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Expires in`;
  }
);
const de_expires_in = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Läuft ab in`;
  }
);
const sp_expires_in = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Expira en`;
  }
);
const expires_in = /* @__NO_SIDE_EFFECTS__ */ (inputs = {}, options = {}) => {
  const locale = options.locale ?? getLocale();
  trackMessageCall("expires_in", locale);
  if (locale === "en") return en_expires_in();
  if (locale === "de") return de_expires_in();
  return sp_expires_in();
};
const en_expires_never = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Expires never`;
  }
);
const de_expires_never = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Läuft nie ab`;
  }
);
const sp_expires_never = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Nunca expira`;
  }
);
const expires_never = /* @__NO_SIDE_EFFECTS__ */ (inputs = {}, options = {}) => {
  const locale = options.locale ?? getLocale();
  trackMessageCall("expires_never", locale);
  if (locale === "en") return en_expires_never();
  if (locale === "de") return de_expires_never();
  return sp_expires_never();
};
const en_expires_seconds = (
  /** @type {(inputs: { number: NonNullable<unknown> }) => string} */
  (i) => {
    return ` ~${i.number} seconds`;
  }
);
const de_expires_seconds = (
  /** @type {(inputs: { number: NonNullable<unknown> }) => string} */
  (i) => {
    return `~${i.number} Sekunden`;
  }
);
const sp_expires_seconds = (
  /** @type {(inputs: { number: NonNullable<unknown> }) => string} */
  (i) => {
    return `~${i.number} segundos`;
  }
);
const expires_seconds = /* @__NO_SIDE_EFFECTS__ */ (inputs, options = {}) => {
  const locale = options.locale ?? getLocale();
  trackMessageCall("expires_seconds", locale);
  if (locale === "en") return en_expires_seconds(inputs);
  if (locale === "de") return de_expires_seconds(inputs);
  return sp_expires_seconds(inputs);
};
const en_expires_minutes = (
  /** @type {(inputs: { number: NonNullable<unknown> }) => string} */
  (i) => {
    return ` ~${i.number} minutes`;
  }
);
const de_expires_minutes = (
  /** @type {(inputs: { number: NonNullable<unknown> }) => string} */
  (i) => {
    return `~${i.number} Minuten`;
  }
);
const sp_expires_minutes = (
  /** @type {(inputs: { number: NonNullable<unknown> }) => string} */
  (i) => {
    return `~${i.number} minutos`;
  }
);
const expires_minutes = /* @__NO_SIDE_EFFECTS__ */ (inputs, options = {}) => {
  const locale = options.locale ?? getLocale();
  trackMessageCall("expires_minutes", locale);
  if (locale === "en") return en_expires_minutes(inputs);
  if (locale === "de") return de_expires_minutes(inputs);
  return sp_expires_minutes(inputs);
};
const en_expires_hours = (
  /** @type {(inputs: { number: NonNullable<unknown> }) => string} */
  (i) => {
    return ` ~${i.number} hours`;
  }
);
const de_expires_hours = (
  /** @type {(inputs: { number: NonNullable<unknown> }) => string} */
  (i) => {
    return `~${i.number} Stunden`;
  }
);
const sp_expires_hours = (
  /** @type {(inputs: { number: NonNullable<unknown> }) => string} */
  (i) => {
    return `~${i.number} horas`;
  }
);
const expires_hours = /* @__NO_SIDE_EFFECTS__ */ (inputs, options = {}) => {
  const locale = options.locale ?? getLocale();
  trackMessageCall("expires_hours", locale);
  if (locale === "en") return en_expires_hours(inputs);
  if (locale === "de") return de_expires_hours(inputs);
  return sp_expires_hours(inputs);
};
const en_expires_days = (
  /** @type {(inputs: { number: NonNullable<unknown> }) => string} */
  (i) => {
    return ` ~${i.number} days`;
  }
);
const de_expires_days = (
  /** @type {(inputs: { number: NonNullable<unknown> }) => string} */
  (i) => {
    return `~${i.number} Tagen`;
  }
);
const sp_expires_days = (
  /** @type {(inputs: { number: NonNullable<unknown> }) => string} */
  (i) => {
    return `~${i.number} días`;
  }
);
const expires_days = /* @__NO_SIDE_EFFECTS__ */ (inputs, options = {}) => {
  const locale = options.locale ?? getLocale();
  trackMessageCall("expires_days", locale);
  if (locale === "en") return en_expires_days(inputs);
  if (locale === "de") return de_expires_days(inputs);
  return sp_expires_days(inputs);
};
const en_expires_weeks = (
  /** @type {(inputs: { number: NonNullable<unknown> }) => string} */
  (i) => {
    return ` ~${i.number} weeks`;
  }
);
const de_expires_weeks = (
  /** @type {(inputs: { number: NonNullable<unknown> }) => string} */
  (i) => {
    return `~${i.number} Wochen`;
  }
);
const sp_expires_weeks = (
  /** @type {(inputs: { number: NonNullable<unknown> }) => string} */
  (i) => {
    return `~${i.number} semanas`;
  }
);
const expires_weeks = /* @__NO_SIDE_EFFECTS__ */ (inputs, options = {}) => {
  const locale = options.locale ?? getLocale();
  trackMessageCall("expires_weeks", locale);
  if (locale === "en") return en_expires_weeks(inputs);
  if (locale === "de") return de_expires_weeks(inputs);
  return sp_expires_weeks(inputs);
};
const en_expires_months = (
  /** @type {(inputs: { number: NonNullable<unknown> }) => string} */
  (i) => {
    return ` ~${i.number} months`;
  }
);
const de_expires_months = (
  /** @type {(inputs: { number: NonNullable<unknown> }) => string} */
  (i) => {
    return `~${i.number} Monaten`;
  }
);
const sp_expires_months = (
  /** @type {(inputs: { number: NonNullable<unknown> }) => string} */
  (i) => {
    return `~${i.number} meses`;
  }
);
const expires_months = /* @__NO_SIDE_EFFECTS__ */ (inputs, options = {}) => {
  const locale = options.locale ?? getLocale();
  trackMessageCall("expires_months", locale);
  if (locale === "en") return en_expires_months(inputs);
  if (locale === "de") return de_expires_months(inputs);
  return sp_expires_months(inputs);
};
const en_expires_years = (
  /** @type {(inputs: { number: NonNullable<unknown> }) => string} */
  (i) => {
    return ` ~${i.number} years`;
  }
);
const de_expires_years = (
  /** @type {(inputs: { number: NonNullable<unknown> }) => string} */
  (i) => {
    return `~${i.number} Jahren`;
  }
);
const sp_expires_years = (
  /** @type {(inputs: { number: NonNullable<unknown> }) => string} */
  (i) => {
    return `~${i.number} años`;
  }
);
const expires_years = /* @__NO_SIDE_EFFECTS__ */ (inputs, options = {}) => {
  const locale = options.locale ?? getLocale();
  trackMessageCall("expires_years", locale);
  if (locale === "en") return en_expires_years(inputs);
  if (locale === "de") return de_expires_years(inputs);
  return sp_expires_years(inputs);
};
const en_copy_link = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Copy link`;
  }
);
const de_copy_link = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Link kopiere`;
  }
);
const sp_copy_link = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Copiar enlace`;
  }
);
const copy_link = /* @__NO_SIDE_EFFECTS__ */ (inputs = {}, options = {}) => {
  const locale = options.locale ?? getLocale();
  trackMessageCall("copy_link", locale);
  if (locale === "en") return en_copy_link();
  if (locale === "de") return de_copy_link();
  return sp_copy_link();
};
const en_copied_link = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Link copied`;
  }
);
const de_copied_link = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Link kopiert`;
  }
);
const sp_copied_link = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Enlace copiado`;
  }
);
const copied_link = /* @__NO_SIDE_EFFECTS__ */ (inputs = {}, options = {}) => {
  const locale = options.locale ?? getLocale();
  trackMessageCall("copied_link", locale);
  if (locale === "en") return en_copied_link();
  if (locale === "de") return de_copied_link();
  return sp_copied_link();
};
const en_delete_link = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Delete link`;
  }
);
const de_delete_link = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Link löschen`;
  }
);
const sp_delete_link = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Eliminar enlace`;
  }
);
const delete_link = /* @__NO_SIDE_EFFECTS__ */ (inputs = {}, options = {}) => {
  const locale = options.locale ?? getLocale();
  trackMessageCall("delete_link", locale);
  if (locale === "en") return en_delete_link();
  if (locale === "de") return de_delete_link();
  return sp_delete_link();
};
const en_create_link = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Create link`;
  }
);
const de_create_link = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Link erstellen`;
  }
);
const sp_create_link = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Crear enlace`;
  }
);
const create_link = /* @__NO_SIDE_EFFECTS__ */ (inputs = {}, options = {}) => {
  const locale = options.locale ?? getLocale();
  trackMessageCall("create_link", locale);
  if (locale === "en") return en_create_link();
  if (locale === "de") return de_create_link();
  return sp_create_link();
};
const en_ttl = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Time to live`;
  }
);
const de_ttl = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Lebensdauer`;
  }
);
const sp_ttl = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Duración`;
  }
);
const ttl = /* @__NO_SIDE_EFFECTS__ */ (inputs = {}, options = {}) => {
  const locale = options.locale ?? getLocale();
  trackMessageCall("ttl", locale);
  if (locale === "en") return en_ttl();
  if (locale === "de") return de_ttl();
  return sp_ttl();
};
const en_call_limit = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Call Limit`;
  }
);
const de_call_limit = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Aufruflimit`;
  }
);
const sp_call_limit = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Límite de utilización`;
  }
);
const call_limit = /* @__NO_SIDE_EFFECTS__ */ (inputs = {}, options = {}) => {
  const locale = options.locale ?? getLocale();
  trackMessageCall("call_limit", locale);
  if (locale === "en") return en_call_limit();
  if (locale === "de") return de_call_limit();
  return sp_call_limit();
};
const en_passphrase = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Password`;
  }
);
const de_passphrase = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Passwort`;
  }
);
const sp_passphrase = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Contraseña`;
  }
);
const passphrase = /* @__NO_SIDE_EFFECTS__ */ (inputs = {}, options = {}) => {
  const locale = options.locale ?? getLocale();
  trackMessageCall("passphrase", locale);
  if (locale === "en") return en_passphrase();
  if (locale === "de") return de_passphrase();
  return sp_passphrase();
};
const en_invalid_minvalue1 = (
  /** @type {(inputs: { requirement: NonNullable<unknown> }) => string} */
  (i) => {
    return `Minimal value is ${i.requirement}`;
  }
);
const de_invalid_minvalue1 = (
  /** @type {(inputs: { requirement: NonNullable<unknown> }) => string} */
  (i) => {
    return `Minimalwert ${i.requirement}`;
  }
);
const sp_invalid_minvalue1 = en_invalid_minvalue1;
const invalid_minvalue1 = /* @__NO_SIDE_EFFECTS__ */ (inputs, options = {}) => {
  const locale = options.locale ?? getLocale();
  trackMessageCall("invalid_minvalue1", locale);
  if (locale === "en") return en_invalid_minvalue1(inputs);
  if (locale === "de") return de_invalid_minvalue1(inputs);
  return sp_invalid_minvalue1(inputs);
};
const en_shrtn_bot_headline = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Ups, the redirection seems to be failed!`;
  }
);
const de_shrtn_bot_headline = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Ups, die Weiterleitung ist fehlgeschlagen!`;
  }
);
const sp_shrtn_bot_headline = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `¡Ups, parece que la redirección ha fallado!`;
  }
);
const shrtn_bot_headline = /* @__NO_SIDE_EFFECTS__ */ (inputs = {}, options = {}) => {
  const locale = options.locale ?? getLocale();
  trackMessageCall("shrtn_bot_headline", locale);
  if (locale === "en") return en_shrtn_bot_headline();
  if (locale === "de") return de_shrtn_bot_headline();
  return sp_shrtn_bot_headline();
};
const en_shrtn_bot_subline = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Click on the link below to access the redirected content.`;
  }
);
const de_shrtn_bot_subline = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Klicken Sie auf den untenstehenden Link, um auf den weitergeleiteten Inhalt zuzugreifen.`;
  }
);
const sp_shrtn_bot_subline = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Haz clic en el enlace de abajo para acceder al contenido redirigido.`;
  }
);
const shrtn_bot_subline = /* @__NO_SIDE_EFFECTS__ */ (inputs = {}, options = {}) => {
  const locale = options.locale ?? getLocale();
  trackMessageCall("shrtn_bot_subline", locale);
  if (locale === "en") return en_shrtn_bot_subline();
  if (locale === "de") return de_shrtn_bot_subline();
  return sp_shrtn_bot_subline();
};
const en_remove = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Remove`;
  }
);
const de_remove = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Entfernen`;
  }
);
const sp_remove = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Eliminar`;
  }
);
const remove = /* @__NO_SIDE_EFFECTS__ */ (inputs = {}, options = {}) => {
  const locale = options.locale ?? getLocale();
  trackMessageCall("remove", locale);
  if (locale === "en") return en_remove();
  if (locale === "de") return de_remove();
  return sp_remove();
};
const en_clicks_left = (
  /** @type {(inputs: { left: NonNullable<unknown>, limit: NonNullable<unknown> }) => string} */
  (i) => {
    return `${i.left} calls left of ${i.limit}`;
  }
);
const de_clicks_left = (
  /** @type {(inputs: { left: NonNullable<unknown>, limit: NonNullable<unknown> }) => string} */
  (i) => {
    return `${i.left} Aufrufe von ${i.limit} übrig`;
  }
);
const sp_clicks_left = (
  /** @type {(inputs: { left: NonNullable<unknown>, limit: NonNullable<unknown> }) => string} */
  (i) => {
    return `${i.left} llamadas restantes de ${i.limit}`;
  }
);
const clicks_left = /* @__NO_SIDE_EFFECTS__ */ (inputs, options = {}) => {
  const locale = options.locale ?? getLocale();
  trackMessageCall("clicks_left", locale);
  if (locale === "en") return en_clicks_left(inputs);
  if (locale === "de") return de_clicks_left(inputs);
  return sp_clicks_left(inputs);
};
const en_protected_link = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Protected Link`;
  }
);
const de_protected_link = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Geschützter Link`;
  }
);
const sp_protected_link = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Enlace protegido`;
  }
);
const protected_link = /* @__NO_SIDE_EFFECTS__ */ (inputs = {}, options = {}) => {
  const locale = options.locale ?? getLocale();
  trackMessageCall("protected_link", locale);
  if (locale === "en") return en_protected_link();
  if (locale === "de") return de_protected_link();
  return sp_protected_link();
};
const en_download = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Download`;
  }
);
const de_download = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Herunterladen`;
  }
);
const sp_download = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Descargar`;
  }
);
const download = /* @__NO_SIDE_EFFECTS__ */ (inputs = {}, options = {}) => {
  const locale = options.locale ?? getLocale();
  trackMessageCall("download", locale);
  if (locale === "en") return en_download();
  if (locale === "de") return de_download();
  return sp_download();
};
const en_close = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Close`;
  }
);
const de_close = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Schließen`;
  }
);
const sp_close = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Cerrar`;
  }
);
const close = /* @__NO_SIDE_EFFECTS__ */ (inputs = {}, options = {}) => {
  const locale = options.locale ?? getLocale();
  trackMessageCall("close", locale);
  if (locale === "en") return en_close();
  if (locale === "de") return de_close();
  return sp_close();
};
const en_qr_code = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `QR Code`;
  }
);
const de_qr_code = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `QR-Code`;
  }
);
const sp_qr_code = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Código QR`;
  }
);
const qr_code = /* @__NO_SIDE_EFFECTS__ */ (inputs = {}, options = {}) => {
  const locale = options.locale ?? getLocale();
  trackMessageCall("qr_code", locale);
  if (locale === "en") return en_qr_code();
  if (locale === "de") return de_qr_code();
  return sp_qr_code();
};
const en_generate_qr_code = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Generate QR Code`;
  }
);
const de_generate_qr_code = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `QR-Code generieren`;
  }
);
const sp_generate_qr_code = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Generar código QR`;
  }
);
const generate_qr_code = /* @__NO_SIDE_EFFECTS__ */ (inputs = {}, options = {}) => {
  const locale = options.locale ?? getLocale();
  trackMessageCall("generate_qr_code", locale);
  if (locale === "en") return en_generate_qr_code();
  if (locale === "de") return de_generate_qr_code();
  return sp_generate_qr_code();
};
const en_download_qr_code = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Download QR Code`;
  }
);
const de_download_qr_code = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `QR-Code herunterladen`;
  }
);
const sp_download_qr_code = (
  /** @type {(inputs: {}) => string} */
  () => {
    return `Descargar código QR`;
  }
);
const download_qr_code = /* @__NO_SIDE_EFFECTS__ */ (inputs = {}, options = {}) => {
  const locale = options.locale ?? getLocale();
  trackMessageCall("download_qr_code", locale);
  if (locale === "en") return en_download_qr_code();
  if (locale === "de") return de_download_qr_code();
  return sp_download_qr_code();
};
const _index = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Link: link1,
  Original_link: original_link1,
  about_link,
  aday,
  amonth,
  anhour,
  aweek,
  ayear,
  call_limit,
  clicks_left,
  close,
  copied_link,
  copy_link,
  create_link,
  delete_link,
  download,
  download_qr_code,
  email,
  email_info,
  error_empty_key,
  error_invalid_email,
  error_invalid_url,
  error_link_min_lenght,
  expires_days,
  expires_hours,
  expires_in,
  expires_minutes,
  expires_months,
  expires_never,
  expires_seconds,
  expires_weeks,
  expires_years,
  forever,
  generate_qr_code,
  github_link_title,
  imprint,
  invalid_email_not_allowed,
  invalid_maxValue: invalid_maxvalue1,
  invalid_minValue: invalid_minvalue1,
  invalid_minVlaue: invalid_minvlaue1,
  invalid_number,
  invalid_private_link,
  link_input_description,
  link_input_placeholder,
  made_with_love,
  meta_description,
  meta_keywords,
  passphrase,
  protected_link,
  qr_code,
  redirect_to,
  remove,
  secret,
  send_again,
  send_failed,
  send_verification,
  sending,
  setup_link,
  shrtn_bot_headline,
  shrtn_bot_subline,
  shrtn_outdated_headline,
  shrtn_outdated_subline,
  shrtn_passphrase_headline,
  shrtn_passphrase_info,
  shrtn_passphrase_invalid,
  shrtn_passphrase_subline,
  shrtn_unsecure_headline,
  shrtn_unsecure_subline,
  sign_in,
  sign_in_link,
  sign_out,
  teaser,
  teaser_sub,
  terms_of_use,
  title,
  ttl,
  unsecure_link,
  verification,
  verification_headline,
  verification_mail_body,
  verification_mail_headline,
  verification_subline,
  verify
}, Symbol.toStringTag, { value: "Module" }));
const m = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Link: link1,
  Original_link: original_link1,
  about_link,
  aday,
  amonth,
  anhour,
  aweek,
  ayear,
  call_limit,
  clicks_left,
  close,
  copied_link,
  copy_link,
  create_link,
  delete_link,
  download,
  download_qr_code,
  email,
  email_info,
  error_empty_key,
  error_invalid_email,
  error_invalid_url,
  error_link_min_lenght,
  expires_days,
  expires_hours,
  expires_in,
  expires_minutes,
  expires_months,
  expires_never,
  expires_seconds,
  expires_weeks,
  expires_years,
  forever,
  generate_qr_code,
  github_link_title,
  imprint,
  invalid_email_not_allowed,
  invalid_maxValue: invalid_maxvalue1,
  invalid_minValue: invalid_minvalue1,
  invalid_minVlaue: invalid_minvlaue1,
  invalid_number,
  invalid_private_link,
  link_input_description,
  link_input_placeholder,
  m: _index,
  made_with_love,
  meta_description,
  meta_keywords,
  passphrase,
  protected_link,
  qr_code,
  redirect_to,
  remove,
  secret,
  send_again,
  send_failed,
  send_verification,
  sending,
  setup_link,
  shrtn_bot_headline,
  shrtn_bot_subline,
  shrtn_outdated_headline,
  shrtn_outdated_subline,
  shrtn_passphrase_headline,
  shrtn_passphrase_info,
  shrtn_passphrase_invalid,
  shrtn_passphrase_subline,
  shrtn_unsecure_headline,
  shrtn_unsecure_subline,
  sign_in,
  sign_in_link,
  sign_out,
  teaser,
  teaser_sub,
  terms_of_use,
  title,
  ttl,
  unsecure_link,
  verification,
  verification_headline,
  verification_mail_body,
  verification_mail_headline,
  verification_subline,
  verify
}, Symbol.toStringTag, { value: "Module" }));
function Clock_fading($$payload, $$props) {
  const $$sanitized_props = sanitize_props($$props);
  /**
   * @license lucide-svelte v0.542.0 - ISC
   *
   * ISC License
   *
   * Copyright (c) for portions of Lucide are held by Cole Bemis 2013-2023 as part of Feather (MIT). All other copyright (c) for Lucide are held by Lucide Contributors 2025.
   *
   * Permission to use, copy, modify, and/or distribute this software for any
   * purpose with or without fee is hereby granted, provided that the above
   * copyright notice and this permission notice appear in all copies.
   *
   * THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
   * WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
   * MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
   * ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
   * WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
   * ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
   * OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
   *
   * ---
   *
   * The MIT License (MIT) (for portions derived from Feather)
   *
   * Copyright (c) 2013-2023 Cole Bemis
   *
   * Permission is hereby granted, free of charge, to any person obtaining a copy
   * of this software and associated documentation files (the "Software"), to deal
   * in the Software without restriction, including without limitation the rights
   * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
   * copies of the Software, and to permit persons to whom the Software is
   * furnished to do so, subject to the following conditions:
   *
   * The above copyright notice and this permission notice shall be included in all
   * copies or substantial portions of the Software.
   *
   * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
   * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
   * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
   * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
   * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
   * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
   * SOFTWARE.
   *
   */
  const iconNode = [
    ["path", { "d": "M12 2a10 10 0 0 1 7.38 16.75" }],
    ["path", { "d": "M12 6v6l4 2" }],
    ["path", { "d": "M2.5 8.875a10 10 0 0 0-.5 3" }],
    ["path", { "d": "M2.83 16a10 10 0 0 0 2.43 3.4" }],
    ["path", { "d": "M4.636 5.235a10 10 0 0 1 .891-.857" }],
    ["path", { "d": "M8.644 21.42a10 10 0 0 0 7.631-.38" }]
  ];
  Icon($$payload, spread_props([
    { name: "clock-fading" },
    $$sanitized_props,
    {
      /**
       * @component @name ClockFading
       * @description Lucide SVG icon component, renders SVG Element with children.
       *
       * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTIgMmExMCAxMCAwIDAgMSA3LjM4IDE2Ljc1IiAvPgogIDxwYXRoIGQ9Ik0xMiA2djZsNCAyIiAvPgogIDxwYXRoIGQ9Ik0yLjUgOC44NzVhMTAgMTAgMCAwIDAtLjUgMyIgLz4KICA8cGF0aCBkPSJNMi44MyAxNmExMCAxMCAwIDAgMCAyLjQzIDMuNCIgLz4KICA8cGF0aCBkPSJNNC42MzYgNS4yMzVhMTAgMTAgMCAwIDEgLjg5MS0uODU3IiAvPgogIDxwYXRoIGQ9Ik04LjY0NCAyMS40MmExMCAxMCAwIDAgMCA3LjYzMS0uMzgiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/clock-fading
       * @see https://lucide.dev/guide/packages/lucide-svelte - Documentation
       *
       * @param {Object} props - Lucide icons props and any valid SVG attribute
       * @returns {FunctionalComponent} Svelte component
       *
       */
      iconNode,
      children: ($$payload2) => {
        $$payload2.out.push(`<!---->`);
        slot($$payload2, $$props, "default", {});
        $$payload2.out.push(`<!---->`);
      },
      $$slots: { default: true }
    }
  ]));
}
function Copy($$payload, $$props) {
  const $$sanitized_props = sanitize_props($$props);
  /**
   * @license lucide-svelte v0.542.0 - ISC
   *
   * ISC License
   *
   * Copyright (c) for portions of Lucide are held by Cole Bemis 2013-2023 as part of Feather (MIT). All other copyright (c) for Lucide are held by Lucide Contributors 2025.
   *
   * Permission to use, copy, modify, and/or distribute this software for any
   * purpose with or without fee is hereby granted, provided that the above
   * copyright notice and this permission notice appear in all copies.
   *
   * THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
   * WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
   * MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
   * ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
   * WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
   * ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
   * OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
   *
   * ---
   *
   * The MIT License (MIT) (for portions derived from Feather)
   *
   * Copyright (c) 2013-2023 Cole Bemis
   *
   * Permission is hereby granted, free of charge, to any person obtaining a copy
   * of this software and associated documentation files (the "Software"), to deal
   * in the Software without restriction, including without limitation the rights
   * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
   * copies of the Software, and to permit persons to whom the Software is
   * furnished to do so, subject to the following conditions:
   *
   * The above copyright notice and this permission notice shall be included in all
   * copies or substantial portions of the Software.
   *
   * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
   * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
   * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
   * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
   * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
   * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
   * SOFTWARE.
   *
   */
  const iconNode = [
    [
      "rect",
      {
        "width": "14",
        "height": "14",
        "x": "8",
        "y": "8",
        "rx": "2",
        "ry": "2"
      }
    ],
    [
      "path",
      {
        "d": "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"
      }
    ]
  ];
  Icon($$payload, spread_props([
    { name: "copy" },
    $$sanitized_props,
    {
      /**
       * @component @name Copy
       * @description Lucide SVG icon component, renders SVG Element with children.
       *
       * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cmVjdCB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHg9IjgiIHk9IjgiIHJ4PSIyIiByeT0iMiIgLz4KICA8cGF0aCBkPSJNNCAxNmMtMS4xIDAtMi0uOS0yLTJWNGMwLTEuMS45LTIgMi0yaDEwYzEuMSAwIDIgLjkgMiAyIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/copy
       * @see https://lucide.dev/guide/packages/lucide-svelte - Documentation
       *
       * @param {Object} props - Lucide icons props and any valid SVG attribute
       * @returns {FunctionalComponent} Svelte component
       *
       */
      iconNode,
      children: ($$payload2) => {
        $$payload2.out.push(`<!---->`);
        slot($$payload2, $$props, "default", {});
        $$payload2.out.push(`<!---->`);
      },
      $$slots: { default: true }
    }
  ]));
}
function Download($$payload, $$props) {
  const $$sanitized_props = sanitize_props($$props);
  /**
   * @license lucide-svelte v0.542.0 - ISC
   *
   * ISC License
   *
   * Copyright (c) for portions of Lucide are held by Cole Bemis 2013-2023 as part of Feather (MIT). All other copyright (c) for Lucide are held by Lucide Contributors 2025.
   *
   * Permission to use, copy, modify, and/or distribute this software for any
   * purpose with or without fee is hereby granted, provided that the above
   * copyright notice and this permission notice appear in all copies.
   *
   * THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
   * WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
   * MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
   * ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
   * WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
   * ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
   * OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
   *
   * ---
   *
   * The MIT License (MIT) (for portions derived from Feather)
   *
   * Copyright (c) 2013-2023 Cole Bemis
   *
   * Permission is hereby granted, free of charge, to any person obtaining a copy
   * of this software and associated documentation files (the "Software"), to deal
   * in the Software without restriction, including without limitation the rights
   * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
   * copies of the Software, and to permit persons to whom the Software is
   * furnished to do so, subject to the following conditions:
   *
   * The above copyright notice and this permission notice shall be included in all
   * copies or substantial portions of the Software.
   *
   * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
   * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
   * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
   * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
   * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
   * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
   * SOFTWARE.
   *
   */
  const iconNode = [
    ["path", { "d": "M12 15V3" }],
    ["path", { "d": "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" }],
    ["path", { "d": "m7 10 5 5 5-5" }]
  ];
  Icon($$payload, spread_props([
    { name: "download" },
    $$sanitized_props,
    {
      /**
       * @component @name Download
       * @description Lucide SVG icon component, renders SVG Element with children.
       *
       * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTIgMTVWMyIgLz4KICA8cGF0aCBkPSJNMjEgMTV2NGEyIDIgMCAwIDEtMiAySDVhMiAyIDAgMCAxLTItMnYtNCIgLz4KICA8cGF0aCBkPSJtNyAxMCA1IDUgNS01IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/download
       * @see https://lucide.dev/guide/packages/lucide-svelte - Documentation
       *
       * @param {Object} props - Lucide icons props and any valid SVG attribute
       * @returns {FunctionalComponent} Svelte component
       *
       */
      iconNode,
      children: ($$payload2) => {
        $$payload2.out.push(`<!---->`);
        slot($$payload2, $$props, "default", {});
        $$payload2.out.push(`<!---->`);
      },
      $$slots: { default: true }
    }
  ]));
}
function Link($$payload, $$props) {
  const $$sanitized_props = sanitize_props($$props);
  /**
   * @license lucide-svelte v0.542.0 - ISC
   *
   * ISC License
   *
   * Copyright (c) for portions of Lucide are held by Cole Bemis 2013-2023 as part of Feather (MIT). All other copyright (c) for Lucide are held by Lucide Contributors 2025.
   *
   * Permission to use, copy, modify, and/or distribute this software for any
   * purpose with or without fee is hereby granted, provided that the above
   * copyright notice and this permission notice appear in all copies.
   *
   * THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
   * WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
   * MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
   * ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
   * WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
   * ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
   * OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
   *
   * ---
   *
   * The MIT License (MIT) (for portions derived from Feather)
   *
   * Copyright (c) 2013-2023 Cole Bemis
   *
   * Permission is hereby granted, free of charge, to any person obtaining a copy
   * of this software and associated documentation files (the "Software"), to deal
   * in the Software without restriction, including without limitation the rights
   * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
   * copies of the Software, and to permit persons to whom the Software is
   * furnished to do so, subject to the following conditions:
   *
   * The above copyright notice and this permission notice shall be included in all
   * copies or substantial portions of the Software.
   *
   * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
   * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
   * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
   * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
   * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
   * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
   * SOFTWARE.
   *
   */
  const iconNode = [
    [
      "path",
      {
        "d": "M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"
      }
    ],
    [
      "path",
      {
        "d": "M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"
      }
    ]
  ];
  Icon($$payload, spread_props([
    { name: "link" },
    $$sanitized_props,
    {
      /**
       * @component @name Link
       * @description Lucide SVG icon component, renders SVG Element with children.
       *
       * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTAgMTNhNSA1IDAgMCAwIDcuNTQuNTRsMy0zYTUgNSAwIDAgMC03LjA3LTcuMDdsLTEuNzIgMS43MSIgLz4KICA8cGF0aCBkPSJNMTQgMTFhNSA1IDAgMCAwLTcuNTQtLjU0bC0zIDNhNSA1IDAgMCAwIDcuMDcgNy4wN2wxLjcxLTEuNzEiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/link
       * @see https://lucide.dev/guide/packages/lucide-svelte - Documentation
       *
       * @param {Object} props - Lucide icons props and any valid SVG attribute
       * @returns {FunctionalComponent} Svelte component
       *
       */
      iconNode,
      children: ($$payload2) => {
        $$payload2.out.push(`<!---->`);
        slot($$payload2, $$props, "default", {});
        $$payload2.out.push(`<!---->`);
      },
      $$slots: { default: true }
    }
  ]));
}
function Loader_circle($$payload, $$props) {
  const $$sanitized_props = sanitize_props($$props);
  /**
   * @license lucide-svelte v0.542.0 - ISC
   *
   * ISC License
   *
   * Copyright (c) for portions of Lucide are held by Cole Bemis 2013-2023 as part of Feather (MIT). All other copyright (c) for Lucide are held by Lucide Contributors 2025.
   *
   * Permission to use, copy, modify, and/or distribute this software for any
   * purpose with or without fee is hereby granted, provided that the above
   * copyright notice and this permission notice appear in all copies.
   *
   * THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
   * WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
   * MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
   * ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
   * WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
   * ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
   * OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
   *
   * ---
   *
   * The MIT License (MIT) (for portions derived from Feather)
   *
   * Copyright (c) 2013-2023 Cole Bemis
   *
   * Permission is hereby granted, free of charge, to any person obtaining a copy
   * of this software and associated documentation files (the "Software"), to deal
   * in the Software without restriction, including without limitation the rights
   * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
   * copies of the Software, and to permit persons to whom the Software is
   * furnished to do so, subject to the following conditions:
   *
   * The above copyright notice and this permission notice shall be included in all
   * copies or substantial portions of the Software.
   *
   * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
   * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
   * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
   * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
   * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
   * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
   * SOFTWARE.
   *
   */
  const iconNode = [["path", { "d": "M21 12a9 9 0 1 1-6.219-8.56" }]];
  Icon($$payload, spread_props([
    { name: "loader-circle" },
    $$sanitized_props,
    {
      /**
       * @component @name LoaderCircle
       * @description Lucide SVG icon component, renders SVG Element with children.
       *
       * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMjEgMTJhOSA5IDAgMSAxLTYuMjE5LTguNTYiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/loader-circle
       * @see https://lucide.dev/guide/packages/lucide-svelte - Documentation
       *
       * @param {Object} props - Lucide icons props and any valid SVG attribute
       * @returns {FunctionalComponent} Svelte component
       *
       */
      iconNode,
      children: ($$payload2) => {
        $$payload2.out.push(`<!---->`);
        slot($$payload2, $$props, "default", {});
        $$payload2.out.push(`<!---->`);
      },
      $$slots: { default: true }
    }
  ]));
}
function Lock($$payload, $$props) {
  const $$sanitized_props = sanitize_props($$props);
  /**
   * @license lucide-svelte v0.542.0 - ISC
   *
   * ISC License
   *
   * Copyright (c) for portions of Lucide are held by Cole Bemis 2013-2023 as part of Feather (MIT). All other copyright (c) for Lucide are held by Lucide Contributors 2025.
   *
   * Permission to use, copy, modify, and/or distribute this software for any
   * purpose with or without fee is hereby granted, provided that the above
   * copyright notice and this permission notice appear in all copies.
   *
   * THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
   * WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
   * MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
   * ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
   * WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
   * ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
   * OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
   *
   * ---
   *
   * The MIT License (MIT) (for portions derived from Feather)
   *
   * Copyright (c) 2013-2023 Cole Bemis
   *
   * Permission is hereby granted, free of charge, to any person obtaining a copy
   * of this software and associated documentation files (the "Software"), to deal
   * in the Software without restriction, including without limitation the rights
   * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
   * copies of the Software, and to permit persons to whom the Software is
   * furnished to do so, subject to the following conditions:
   *
   * The above copyright notice and this permission notice shall be included in all
   * copies or substantial portions of the Software.
   *
   * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
   * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
   * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
   * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
   * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
   * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
   * SOFTWARE.
   *
   */
  const iconNode = [
    [
      "rect",
      {
        "width": "18",
        "height": "11",
        "x": "3",
        "y": "11",
        "rx": "2",
        "ry": "2"
      }
    ],
    ["path", { "d": "M7 11V7a5 5 0 0 1 10 0v4" }]
  ];
  Icon($$payload, spread_props([
    { name: "lock" },
    $$sanitized_props,
    {
      /**
       * @component @name Lock
       * @description Lucide SVG icon component, renders SVG Element with children.
       *
       * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cmVjdCB3aWR0aD0iMTgiIGhlaWdodD0iMTEiIHg9IjMiIHk9IjExIiByeD0iMiIgcnk9IjIiIC8+CiAgPHBhdGggZD0iTTcgMTFWN2E1IDUgMCAwIDEgMTAgMHY0IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/lock
       * @see https://lucide.dev/guide/packages/lucide-svelte - Documentation
       *
       * @param {Object} props - Lucide icons props and any valid SVG attribute
       * @returns {FunctionalComponent} Svelte component
       *
       */
      iconNode,
      children: ($$payload2) => {
        $$payload2.out.push(`<!---->`);
        slot($$payload2, $$props, "default", {});
        $$payload2.out.push(`<!---->`);
      },
      $$slots: { default: true }
    }
  ]));
}
function Mouse_pointer_click($$payload, $$props) {
  const $$sanitized_props = sanitize_props($$props);
  /**
   * @license lucide-svelte v0.542.0 - ISC
   *
   * ISC License
   *
   * Copyright (c) for portions of Lucide are held by Cole Bemis 2013-2023 as part of Feather (MIT). All other copyright (c) for Lucide are held by Lucide Contributors 2025.
   *
   * Permission to use, copy, modify, and/or distribute this software for any
   * purpose with or without fee is hereby granted, provided that the above
   * copyright notice and this permission notice appear in all copies.
   *
   * THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
   * WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
   * MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
   * ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
   * WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
   * ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
   * OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
   *
   * ---
   *
   * The MIT License (MIT) (for portions derived from Feather)
   *
   * Copyright (c) 2013-2023 Cole Bemis
   *
   * Permission is hereby granted, free of charge, to any person obtaining a copy
   * of this software and associated documentation files (the "Software"), to deal
   * in the Software without restriction, including without limitation the rights
   * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
   * copies of the Software, and to permit persons to whom the Software is
   * furnished to do so, subject to the following conditions:
   *
   * The above copyright notice and this permission notice shall be included in all
   * copies or substantial portions of the Software.
   *
   * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
   * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
   * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
   * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
   * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
   * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
   * SOFTWARE.
   *
   */
  const iconNode = [
    ["path", { "d": "M14 4.1 12 6" }],
    ["path", { "d": "m5.1 8-2.9-.8" }],
    ["path", { "d": "m6 12-1.9 2" }],
    ["path", { "d": "M7.2 2.2 8 5.1" }],
    [
      "path",
      {
        "d": "M9.037 9.69a.498.498 0 0 1 .653-.653l11 4.5a.5.5 0 0 1-.074.949l-4.349 1.041a1 1 0 0 0-.74.739l-1.04 4.35a.5.5 0 0 1-.95.074z"
      }
    ]
  ];
  Icon($$payload, spread_props([
    { name: "mouse-pointer-click" },
    $$sanitized_props,
    {
      /**
       * @component @name MousePointerClick
       * @description Lucide SVG icon component, renders SVG Element with children.
       *
       * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTQgNC4xIDEyIDYiIC8+CiAgPHBhdGggZD0ibTUuMSA4LTIuOS0uOCIgLz4KICA8cGF0aCBkPSJtNiAxMi0xLjkgMiIgLz4KICA8cGF0aCBkPSJNNy4yIDIuMiA4IDUuMSIgLz4KICA8cGF0aCBkPSJNOS4wMzcgOS42OWEuNDk4LjQ5OCAwIDAgMSAuNjUzLS42NTNsMTEgNC41YS41LjUgMCAwIDEtLjA3NC45NDlsLTQuMzQ5IDEuMDQxYTEgMSAwIDAgMC0uNzQuNzM5bC0xLjA0IDQuMzVhLjUuNSAwIDAgMS0uOTUuMDc0eiIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/mouse-pointer-click
       * @see https://lucide.dev/guide/packages/lucide-svelte - Documentation
       *
       * @param {Object} props - Lucide icons props and any valid SVG attribute
       * @returns {FunctionalComponent} Svelte component
       *
       */
      iconNode,
      children: ($$payload2) => {
        $$payload2.out.push(`<!---->`);
        slot($$payload2, $$props, "default", {});
        $$payload2.out.push(`<!---->`);
      },
      $$slots: { default: true }
    }
  ]));
}
function Plus($$payload, $$props) {
  const $$sanitized_props = sanitize_props($$props);
  /**
   * @license lucide-svelte v0.542.0 - ISC
   *
   * ISC License
   *
   * Copyright (c) for portions of Lucide are held by Cole Bemis 2013-2023 as part of Feather (MIT). All other copyright (c) for Lucide are held by Lucide Contributors 2025.
   *
   * Permission to use, copy, modify, and/or distribute this software for any
   * purpose with or without fee is hereby granted, provided that the above
   * copyright notice and this permission notice appear in all copies.
   *
   * THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
   * WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
   * MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
   * ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
   * WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
   * ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
   * OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
   *
   * ---
   *
   * The MIT License (MIT) (for portions derived from Feather)
   *
   * Copyright (c) 2013-2023 Cole Bemis
   *
   * Permission is hereby granted, free of charge, to any person obtaining a copy
   * of this software and associated documentation files (the "Software"), to deal
   * in the Software without restriction, including without limitation the rights
   * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
   * copies of the Software, and to permit persons to whom the Software is
   * furnished to do so, subject to the following conditions:
   *
   * The above copyright notice and this permission notice shall be included in all
   * copies or substantial portions of the Software.
   *
   * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
   * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
   * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
   * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
   * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
   * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
   * SOFTWARE.
   *
   */
  const iconNode = [["path", { "d": "M5 12h14" }], ["path", { "d": "M12 5v14" }]];
  Icon($$payload, spread_props([
    { name: "plus" },
    $$sanitized_props,
    {
      /**
       * @component @name Plus
       * @description Lucide SVG icon component, renders SVG Element with children.
       *
       * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNNSAxMmgxNCIgLz4KICA8cGF0aCBkPSJNMTIgNXYxNCIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/plus
       * @see https://lucide.dev/guide/packages/lucide-svelte - Documentation
       *
       * @param {Object} props - Lucide icons props and any valid SVG attribute
       * @returns {FunctionalComponent} Svelte component
       *
       */
      iconNode,
      children: ($$payload2) => {
        $$payload2.out.push(`<!---->`);
        slot($$payload2, $$props, "default", {});
        $$payload2.out.push(`<!---->`);
      },
      $$slots: { default: true }
    }
  ]));
}
function Qr_code($$payload, $$props) {
  const $$sanitized_props = sanitize_props($$props);
  /**
   * @license lucide-svelte v0.542.0 - ISC
   *
   * ISC License
   *
   * Copyright (c) for portions of Lucide are held by Cole Bemis 2013-2023 as part of Feather (MIT). All other copyright (c) for Lucide are held by Lucide Contributors 2025.
   *
   * Permission to use, copy, modify, and/or distribute this software for any
   * purpose with or without fee is hereby granted, provided that the above
   * copyright notice and this permission notice appear in all copies.
   *
   * THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
   * WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
   * MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
   * ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
   * WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
   * ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
   * OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
   *
   * ---
   *
   * The MIT License (MIT) (for portions derived from Feather)
   *
   * Copyright (c) 2013-2023 Cole Bemis
   *
   * Permission is hereby granted, free of charge, to any person obtaining a copy
   * of this software and associated documentation files (the "Software"), to deal
   * in the Software without restriction, including without limitation the rights
   * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
   * copies of the Software, and to permit persons to whom the Software is
   * furnished to do so, subject to the following conditions:
   *
   * The above copyright notice and this permission notice shall be included in all
   * copies or substantial portions of the Software.
   *
   * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
   * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
   * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
   * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
   * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
   * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
   * SOFTWARE.
   *
   */
  const iconNode = [
    [
      "rect",
      { "width": "5", "height": "5", "x": "3", "y": "3", "rx": "1" }
    ],
    [
      "rect",
      { "width": "5", "height": "5", "x": "16", "y": "3", "rx": "1" }
    ],
    [
      "rect",
      { "width": "5", "height": "5", "x": "3", "y": "16", "rx": "1" }
    ],
    ["path", { "d": "M21 16h-3a2 2 0 0 0-2 2v3" }],
    ["path", { "d": "M21 21v.01" }],
    ["path", { "d": "M12 7v3a2 2 0 0 1-2 2H7" }],
    ["path", { "d": "M3 12h.01" }],
    ["path", { "d": "M12 3h.01" }],
    ["path", { "d": "M12 16v.01" }],
    ["path", { "d": "M16 12h1" }],
    ["path", { "d": "M21 12v.01" }],
    ["path", { "d": "M12 21v-1" }]
  ];
  Icon($$payload, spread_props([
    { name: "qr-code" },
    $$sanitized_props,
    {
      /**
       * @component @name QrCode
       * @description Lucide SVG icon component, renders SVG Element with children.
       *
       * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cmVjdCB3aWR0aD0iNSIgaGVpZ2h0PSI1IiB4PSIzIiB5PSIzIiByeD0iMSIgLz4KICA8cmVjdCB3aWR0aD0iNSIgaGVpZ2h0PSI1IiB4PSIxNiIgeT0iMyIgcng9IjEiIC8+CiAgPHJlY3Qgd2lkdGg9IjUiIGhlaWdodD0iNSIgeD0iMyIgeT0iMTYiIHJ4PSIxIiAvPgogIDxwYXRoIGQ9Ik0yMSAxNmgtM2EyIDIgMCAwIDAtMiAydjMiIC8+CiAgPHBhdGggZD0iTTIxIDIxdi4wMSIgLz4KICA8cGF0aCBkPSJNMTIgN3YzYTIgMiAwIDAgMS0yIDJINyIgLz4KICA8cGF0aCBkPSJNMyAxMmguMDEiIC8+CiAgPHBhdGggZD0iTTEyIDNoLjAxIiAvPgogIDxwYXRoIGQ9Ik0xMiAxNnYuMDEiIC8+CiAgPHBhdGggZD0iTTE2IDEyaDEiIC8+CiAgPHBhdGggZD0iTTIxIDEydi4wMSIgLz4KICA8cGF0aCBkPSJNMTIgMjF2LTEiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/qr-code
       * @see https://lucide.dev/guide/packages/lucide-svelte - Documentation
       *
       * @param {Object} props - Lucide icons props and any valid SVG attribute
       * @returns {FunctionalComponent} Svelte component
       *
       */
      iconNode,
      children: ($$payload2) => {
        $$payload2.out.push(`<!---->`);
        slot($$payload2, $$props, "default", {});
        $$payload2.out.push(`<!---->`);
      },
      $$slots: { default: true }
    }
  ]));
}
function Trash_2($$payload, $$props) {
  const $$sanitized_props = sanitize_props($$props);
  /**
   * @license lucide-svelte v0.542.0 - ISC
   *
   * ISC License
   *
   * Copyright (c) for portions of Lucide are held by Cole Bemis 2013-2023 as part of Feather (MIT). All other copyright (c) for Lucide are held by Lucide Contributors 2025.
   *
   * Permission to use, copy, modify, and/or distribute this software for any
   * purpose with or without fee is hereby granted, provided that the above
   * copyright notice and this permission notice appear in all copies.
   *
   * THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
   * WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
   * MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
   * ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
   * WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
   * ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
   * OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
   *
   * ---
   *
   * The MIT License (MIT) (for portions derived from Feather)
   *
   * Copyright (c) 2013-2023 Cole Bemis
   *
   * Permission is hereby granted, free of charge, to any person obtaining a copy
   * of this software and associated documentation files (the "Software"), to deal
   * in the Software without restriction, including without limitation the rights
   * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
   * copies of the Software, and to permit persons to whom the Software is
   * furnished to do so, subject to the following conditions:
   *
   * The above copyright notice and this permission notice shall be included in all
   * copies or substantial portions of the Software.
   *
   * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
   * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
   * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
   * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
   * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
   * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
   * SOFTWARE.
   *
   */
  const iconNode = [
    ["path", { "d": "M10 11v6" }],
    ["path", { "d": "M14 11v6" }],
    ["path", { "d": "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6" }],
    ["path", { "d": "M3 6h18" }],
    ["path", { "d": "M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" }]
  ];
  Icon($$payload, spread_props([
    { name: "trash-2" },
    $$sanitized_props,
    {
      /**
       * @component @name Trash2
       * @description Lucide SVG icon component, renders SVG Element with children.
       *
       * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTAgMTF2NiIgLz4KICA8cGF0aCBkPSJNMTQgMTF2NiIgLz4KICA8cGF0aCBkPSJNMTkgNnYxNGEyIDIgMCAwIDEtMiAySDdhMiAyIDAgMCAxLTItMlY2IiAvPgogIDxwYXRoIGQ9Ik0zIDZoMTgiIC8+CiAgPHBhdGggZD0iTTggNlY0YTIgMiAwIDAgMSAyLTJoNGEyIDIgMCAwIDEgMiAydjIiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/trash-2
       * @see https://lucide.dev/guide/packages/lucide-svelte - Documentation
       *
       * @param {Object} props - Lucide icons props and any valid SVG attribute
       * @returns {FunctionalComponent} Svelte component
       *
       */
      iconNode,
      children: ($$payload2) => {
        $$payload2.out.push(`<!---->`);
        slot($$payload2, $$props, "default", {});
        $$payload2.out.push(`<!---->`);
      },
      $$slots: { default: true }
    }
  ]));
}
function X($$payload, $$props) {
  const $$sanitized_props = sanitize_props($$props);
  /**
   * @license lucide-svelte v0.542.0 - ISC
   *
   * ISC License
   *
   * Copyright (c) for portions of Lucide are held by Cole Bemis 2013-2023 as part of Feather (MIT). All other copyright (c) for Lucide are held by Lucide Contributors 2025.
   *
   * Permission to use, copy, modify, and/or distribute this software for any
   * purpose with or without fee is hereby granted, provided that the above
   * copyright notice and this permission notice appear in all copies.
   *
   * THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
   * WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
   * MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
   * ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
   * WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
   * ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
   * OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
   *
   * ---
   *
   * The MIT License (MIT) (for portions derived from Feather)
   *
   * Copyright (c) 2013-2023 Cole Bemis
   *
   * Permission is hereby granted, free of charge, to any person obtaining a copy
   * of this software and associated documentation files (the "Software"), to deal
   * in the Software without restriction, including without limitation the rights
   * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
   * copies of the Software, and to permit persons to whom the Software is
   * furnished to do so, subject to the following conditions:
   *
   * The above copyright notice and this permission notice shall be included in all
   * copies or substantial portions of the Software.
   *
   * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
   * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
   * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
   * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
   * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
   * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
   * SOFTWARE.
   *
   */
  const iconNode = [
    ["path", { "d": "M18 6 6 18" }],
    ["path", { "d": "m6 6 12 12" }]
  ];
  Icon($$payload, spread_props([
    { name: "x" },
    $$sanitized_props,
    {
      /**
       * @component @name X
       * @description Lucide SVG icon component, renders SVG Element with children.
       *
       * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTggNiA2IDE4IiAvPgogIDxwYXRoIGQ9Im02IDYgMTIgMTIiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/x
       * @see https://lucide.dev/guide/packages/lucide-svelte - Documentation
       *
       * @param {Object} props - Lucide icons props and any valid SVG attribute
       * @returns {FunctionalComponent} Svelte component
       *
       */
      iconNode,
      children: ($$payload2) => {
        $$payload2.out.push(`<!---->`);
        slot($$payload2, $$props, "default", {});
        $$payload2.out.push(`<!---->`);
      },
      $$slots: { default: true }
    }
  ]));
}
function OptionalInputFrame($$payload, $$props) {
  push();
  let {
    label,
    required,
    for: forInput,
    error,
    onselect,
    onremove,
    children
  } = $$props;
  let active = !!required;
  if (required || active) {
    $$payload.out.push("<!--[-->");
    $$payload.out.push(`<div>`);
    InputFrame($$payload, {
      error,
      small: true,
      label,
      for: forInput,
      children: ($$payload2) => {
        Button($$payload2, {
          title: /* @__PURE__ */ remove(),
          transparent: true,
          disabled: required,
          onclick: () => active = false,
          children: ($$payload3) => {
            X($$payload3, { size: 16 });
          },
          $$slots: { default: true }
        });
        $$payload2.out.push(`<!----> `);
        children($$payload2);
        $$payload2.out.push(`<!---->`);
      },
      $$slots: { default: true }
    });
    $$payload.out.push(`<!----></div>`);
  } else {
    $$payload.out.push("<!--[!-->");
    $$payload.out.push(`<div class="my-4">`);
    Button($$payload, {
      transparent: true,
      onclick: () => active = true,
      children: ($$payload2) => {
        Plus($$payload2, {});
        $$payload2.out.push(`<!----> `);
        if (typeof label === "string") {
          $$payload2.out.push("<!--[-->");
          $$payload2.out.push(`${escape_html(label)}`);
        } else {
          $$payload2.out.push("<!--[!-->");
          label($$payload2);
          $$payload2.out.push(`<!---->`);
        }
        $$payload2.out.push(`<!--]-->`);
      },
      $$slots: { default: true }
    });
    $$payload.out.push(`<!----></div>`);
  }
  $$payload.out.push(`<!--]-->`);
  pop();
}
function Select($$payload, $$props) {
  push();
  let { children, value = void 0, $$slots, $$events, ...props } = $$props;
  $$payload.out.push(`<select${spread_attributes({ ...props }, "svelte-f1nltj")}>`);
  $$payload.select_value = { value, ...props }?.value;
  children($$payload);
  $$payload.out.push(`<!---->`);
  $$payload.select_value = void 0;
  $$payload.out.push(`</select>`);
  bind_props($$props, { value });
  pop();
}
function Modal($$payload, $$props) {
  push();
  let { show = true, children, $$slots, $$events, ...props } = $$props;
  $$payload.out.push(`<dialog${spread_attributes({ ...props }, "svelte-1jqhktf")}>`);
  children?.($$payload);
  $$payload.out.push(`<!----></dialog>`);
  bind_props($$props, { show });
  pop();
}
function QRModal($$payload, $$props) {
  push();
  let { show = true, name, value } = $$props;
  const getQRCode = async (url) => {
    const qrCode = await QRCode.toDataURL(url, { errorCorrectionLevel: "H" });
    const [header, base64] = qrCode.split(",");
    if (!header) throw new Error("Invalid QR code");
    const mime = header.match(/data:(.*);base64/)?.[1];
    if (!mime) throw new Error("Invalid MIME type");
    const binary = atob(base64);
    const len = binary.length;
    const buf = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      buf[i] = binary.charCodeAt(i);
    }
    const blob = new Blob([buf], { type: mime });
    const blobUrl = URL.createObjectURL(blob);
    const filename = `${name || "qr-code"}.${mime.split("/")[1]}`;
    return [blobUrl, filename];
  };
  const close$1 = () => {
    show = false;
  };
  let $$settled = true;
  let $$inner_payload;
  function $$render_inner($$payload2) {
    Modal($$payload2, {
      get show() {
        return show;
      },
      set show($$value) {
        show = $$value;
        $$settled = false;
      },
      children: ($$payload3) => {
        $$payload3.out.push(`<div class="modal-content svelte-1l5z9ia"><canvas></canvas> <div class="actions svelte-1l5z9ia">`);
        await_block(
          $$payload3,
          getQRCode(value),
          () => {
            Loader_circle($$payload3, { class: "animate-spin" });
          },
          ([dataLink, filename]) => {
            AnchorButton($$payload3, {
              href: dataLink,
              download: filename,
              transparent: true,
              title: /* @__PURE__ */ download_qr_code(),
              children: ($$payload4) => {
                Download($$payload4, {});
              },
              $$slots: { default: true }
            });
          }
        );
        $$payload3.out.push(`<!--]--> `);
        Button($$payload3, {
          onclick: close$1,
          transparent: true,
          danger: true,
          title: /* @__PURE__ */ close(),
          children: ($$payload4) => {
            X($$payload4, {});
          },
          $$slots: { default: true }
        });
        $$payload3.out.push(`<!----></div></div>`);
      },
      $$slots: { default: true }
    });
  }
  do {
    $$settled = true;
    $$inner_payload = copy_payload($$payload);
    $$render_inner($$inner_payload);
  } while (!$$settled);
  assign_payload($$payload, $$inner_payload);
  bind_props($$props, { show });
  pop();
}
function LinkTile($$payload, $$props) {
  push();
  const {
    url,
    key,
    origin,
    expiresAt,
    hasPassphrase,
    callLimit,
    calls,
    deletePath,
    ondeleted
  } = $$props;
  let showModal = false;
  const shrtnUrl = new URL(key, origin);
  const { hostname } = new URL(url);
  const favicon = `https://icons.duckduckgo.com/ip3/${hostname}.ico`;
  const calcTimeLeft = (expiresAt2) => {
    const now = /* @__PURE__ */ new Date();
    const diff = expiresAt2.getTime() - now.getTime();
    const days = Math.floor(diff / (1e3 * 60 * 60 * 24));
    const hours = Math.floor(diff % (1e3 * 60 * 60 * 24) / (1e3 * 60 * 60));
    const minutes = Math.floor(diff % (1e3 * 60 * 60) / (1e3 * 60));
    const seconds = Math.floor(diff % (1e3 * 60) / 1e3);
    return { days, hours, minutes, seconds };
  };
  const getExpiresInText = (expiresAt2) => {
    if (!expiresAt2) return /* @__PURE__ */ expires_never();
    const { days, hours, minutes } = calcTimeLeft(expiresAt2);
    if (days > 70) return /* @__PURE__ */ expires_months({ number: Math.floor(days / 30) });
    if (days > 14) return /* @__PURE__ */ expires_weeks({ number: Math.floor(days / 7) });
    if (days > 2) return /* @__PURE__ */ expires_days({ number: days });
    if (hours > 2) return /* @__PURE__ */ expires_hours({ number: days * 24 + hours });
    return /* @__PURE__ */ expires_minutes({ number: hours * 60 + minutes });
  };
  let expiresText = getExpiresInText(expiresAt);
  let $$settled = true;
  let $$inner_payload;
  function $$render_inner($$payload2) {
    if (showModal) {
      $$payload2.out.push("<!--[-->");
      QRModal($$payload2, {
        name: `shrtn_qr_${stringify(key)}`,
        value: shrtnUrl.href,
        get show() {
          return showModal;
        },
        set show($$value) {
          showModal = $$value;
          $$settled = false;
        }
      });
    } else {
      $$payload2.out.push("<!--[!-->");
    }
    $$payload2.out.push(`<!--]--> <section class="svelte-5zfddh"><a${attr("href", url)} target="_blank" class="link svelte-5zfddh"><img${attr("src", favicon)}${attr("alt", `Icon of ${hostname}`)} class="svelte-5zfddh"/> <div class="shorted svelte-5zfddh">${escape_html(shrtnUrl.hostname)}${escape_html(shrtnUrl.pathname)}</div> <p class="tourl svelte-5zfddh">${escape_html(url)}</p></a> <div class="options svelte-5zfddh">`);
    if (expiresAt) {
      $$payload2.out.push("<!--[-->");
      $$payload2.out.push(`<div${attr("title", /* @__PURE__ */ expires_in() + " " + expiresText)} class="svelte-5zfddh">`);
      Clock_fading($$payload2, {});
      $$payload2.out.push(`<!----> ${escape_html(expiresText)}</div>`);
    } else {
      $$payload2.out.push("<!--[!-->");
    }
    $$payload2.out.push(`<!--]--> `);
    if (callLimit) {
      $$payload2.out.push("<!--[-->");
      $$payload2.out.push(`<div${attr("title", /* @__PURE__ */ clicks_left({ left: callLimit - (calls ?? 0), limit: callLimit }))} class="svelte-5zfddh">`);
      Mouse_pointer_click($$payload2, {});
      $$payload2.out.push(`<!----> ${escape_html(callLimit - (calls ?? 0))}</div>`);
    } else {
      $$payload2.out.push("<!--[!-->");
    }
    $$payload2.out.push(`<!--]--> `);
    if (hasPassphrase) {
      $$payload2.out.push("<!--[-->");
      $$payload2.out.push(`<div${attr("title", /* @__PURE__ */ protected_link())} class="svelte-5zfddh">`);
      Lock($$payload2, {});
      $$payload2.out.push(`<!----></div>`);
    } else {
      $$payload2.out.push("<!--[!-->");
    }
    $$payload2.out.push(`<!--]--></div> <div class="actions svelte-5zfddh">`);
    Button($$payload2, {
      onclick: () => navigator.clipboard.writeText(shrtnUrl.href),
      transparent: true,
      title: /* @__PURE__ */ copy_link(),
      children: ($$payload3) => {
        Copy($$payload3, {});
      },
      $$slots: { default: true }
    });
    $$payload2.out.push(`<!----> `);
    Button($$payload2, {
      onclick: () => showModal = true,
      download: `shrtn_qr_${stringify(key)}`,
      transparent: true,
      title: /* @__PURE__ */ generate_qr_code(),
      children: ($$payload3) => {
        Qr_code($$payload3, {});
      },
      $$slots: { default: true }
    });
    $$payload2.out.push(`<!----> `);
    if (deletePath) {
      $$payload2.out.push("<!--[-->");
      $$payload2.out.push(`<form class="col-start-2" method="POST"${attr("action", deletePath)}>`);
      Button($$payload2, {
        type: "submit",
        outline: true,
        danger: true,
        title: /* @__PURE__ */ delete_link(),
        children: ($$payload3) => {
          Trash_2($$payload3, {});
        },
        $$slots: { default: true }
      });
      $$payload2.out.push(`<!----> <input name="key"${attr("value", key)} hidden/></form>`);
    } else {
      $$payload2.out.push("<!--[!-->");
    }
    $$payload2.out.push(`<!--]--></div></section>`);
  }
  do {
    $$settled = true;
    $$inner_payload = copy_payload($$payload);
    $$render_inner($$inner_payload);
  } while (!$$settled);
  assign_payload($$payload, $$inner_payload);
  pop();
}
function _page($$payload, $$props) {
  push();
  var $$store_subs;
  const isLoggedIn = (user) => {
    return user != null && !user.temp;
  };
  const { data } = $$props;
  let links = data.links;
  const ttls = getTTLs(isLoggedIn(data.user)).reverse();
  const ttlsWithoutForever = ttls.filter(([num]) => num !== Infinity);
  const schema = getLinkSchema(isLoggedIn(data.user));
  const { form, errors, validate, submitting, message } = superForm(data.form, {
    validators: valibotClient(schema),
    resetForm: true,
    onResult: async ({ result }) => {
      store_mutate($$store_subs ??= {}, "$form", form, store_get($$store_subs ??= {}, "$form", form).short = nanoid(SHORTEN_LENGTH));
      if (result.type === "success") {
        const { data: data2 } = result.data;
        addLink(data2);
      }
    },
    onError: () => {
      store_mutate($$store_subs ??= {}, "$form", form, store_get($$store_subs ??= {}, "$form", form).short = nanoid(SHORTEN_LENGTH));
    }
  });
  const addLink = (link) => {
    links.push({
      ...link,
      expiresAt: link.expiresAt ? new Date(link.expiresAt) : null
    });
  };
  const removeLink = (key) => {
    links = links.filter((l) => l.key !== key);
  };
  const setTtlToYear = () => {
    if (store_get($$store_subs ??= {}, "$form", form).ttl === Infinity) {
      store_mutate($$store_subs ??= {}, "$form", form, store_get($$store_subs ??= {}, "$form", form).ttl = ttlsWithoutForever[0][0]);
    }
  };
  const setTtlToInfinity = () => {
    if (store_get($$store_subs ??= {}, "$form", form).ttl === Infinity) {
      store_mutate($$store_subs ??= {}, "$form", form, store_get($$store_subs ??= {}, "$form", form).ttl = Infinity);
    }
  };
  let $$settled = true;
  let $$inner_payload;
  function $$render_inner($$payload2) {
    $$payload2.out.push(`<main class="svelte-1a9vj7w"><h1 class="svelte-1a9vj7w">shrtn</h1> <p>${escape_html(/* @__PURE__ */ teaser())} - <b>${escape_html(/* @__PURE__ */ teaser_sub())}</b>.</p> <section class="links svelte-1a9vj7w"><form method="POST" action="?/add" class="svelte-1a9vj7w">`);
    InputFrame($$payload2, {
      large: true,
      info: /* @__PURE__ */ link_input_description(),
      error: store_get($$store_subs ??= {}, "$errors", errors).link?.[0] || store_get($$store_subs ??= {}, "$message", message),
      children: ($$payload3) => {
        Input($$payload3, {
          name: "link",
          placeholder: /* @__PURE__ */ link_input_placeholder(),
          autocomplete: "off",
          get value() {
            return store_get($$store_subs ??= {}, "$form", form).link;
          },
          set value($$value) {
            store_mutate($$store_subs ??= {}, "$form", form, store_get($$store_subs ??= {}, "$form", form).link = $$value);
            $$settled = false;
          }
        });
        $$payload3.out.push(`<!----> `);
        Button($$payload3, {
          type: "submit",
          title: /* @__PURE__ */ create_link(),
          children: ($$payload4) => {
            Link($$payload4, {
              size: 16,
              class: store_get($$store_subs ??= {}, "$submitting", submitting) ? "animate-spin" : ""
            });
          },
          $$slots: { default: true }
        });
        $$payload3.out.push(`<!---->`);
      },
      $$slots: { default: true }
    });
    $$payload2.out.push(`<!----> <ul class="optional-definitions svelte-1a9vj7w"><li class="svelte-1a9vj7w">`);
    {
      let label = function($$payload3) {
        $$payload3.out.push(`<!---->${escape_html(/* @__PURE__ */ ttl())}`);
        Clock_fading($$payload3, {});
        $$payload3.out.push(`<!---->`);
      };
      OptionalInputFrame($$payload2, {
        for: "ttl-input",
        required: !couldTLLInfinit(isLoggedIn(data.user)),
        onselect: setTtlToYear,
        onremove: setTtlToInfinity,
        label,
        children: ($$payload3) => {
          Select($$payload3, {
            id: "ttl-input",
            name: "ttl",
            get value() {
              return store_get($$store_subs ??= {}, "$form", form).ttl;
            },
            set value($$value) {
              store_mutate($$store_subs ??= {}, "$form", form, store_get($$store_subs ??= {}, "$form", form).ttl = $$value);
              $$settled = false;
            },
            children: ($$payload4) => {
              const each_array = ensure_array_like(ttlsWithoutForever);
              $$payload4.out.push(`<!--[-->`);
              for (let $$index = 0, $$length = each_array.length; $$index < $$length; $$index++) {
                let [time, text] = each_array[$$index];
                $$payload4.out.push(`<option${attr("value", time)}${maybe_selected($$payload4, time)}>${escape_html(m[text]())}</option>`);
              }
              $$payload4.out.push(`<!--]-->`);
            },
            $$slots: { default: true }
          });
        }
      });
    }
    $$payload2.out.push(`<!----></li> <li class="svelte-1a9vj7w">`);
    {
      let label = function($$payload3) {
        $$payload3.out.push(`<!---->${escape_html(/* @__PURE__ */ call_limit())}`);
        Mouse_pointer_click($$payload3, {});
        $$payload3.out.push(`<!---->`);
      };
      OptionalInputFrame($$payload2, {
        onremove: () => store_mutate($$store_subs ??= {}, "$form", form, store_get($$store_subs ??= {}, "$form", form).callLimit = void 0),
        for: "call-limit-input",
        error: store_get($$store_subs ??= {}, "$errors", errors).callLimit?.[0],
        label,
        children: ($$payload3) => {
          Input($$payload3, {
            onkeyup: () => validate("callLimit"),
            id: "call-limit-input",
            name: "callLimit",
            type: "number",
            placeholder: "amount",
            class: "max-sx:!w-30",
            get value() {
              return store_get($$store_subs ??= {}, "$form", form).callLimit;
            },
            set value($$value) {
              store_mutate($$store_subs ??= {}, "$form", form, store_get($$store_subs ??= {}, "$form", form).callLimit = $$value);
              $$settled = false;
            }
          });
        }
      });
    }
    $$payload2.out.push(`<!----></li> <li class="svelte-1a9vj7w">`);
    {
      let label = function($$payload3) {
        $$payload3.out.push(`<!---->${escape_html(/* @__PURE__ */ passphrase())}`);
        Lock($$payload3, {});
        $$payload3.out.push(`<!---->`);
      };
      OptionalInputFrame($$payload2, {
        onremove: () => store_mutate($$store_subs ??= {}, "$form", form, store_get($$store_subs ??= {}, "$form", form).passphrase = void 0),
        for: "link-passphrase-input",
        label,
        children: ($$payload3) => {
          Input($$payload3, {
            id: "link-passphrase-input",
            name: "passphrase",
            placeholder: "****",
            type: "password",
            get value() {
              return store_get($$store_subs ??= {}, "$form", form).passphrase;
            },
            set value($$value) {
              store_mutate($$store_subs ??= {}, "$form", form, store_get($$store_subs ??= {}, "$form", form).passphrase = $$value);
              $$settled = false;
            }
          });
        }
      });
    }
    $$payload2.out.push(`<!----></li></ul></form> `);
    if (data) {
      $$payload2.out.push("<!--[-->");
      const each_array_1 = ensure_array_like(links);
      $$payload2.out.push(`<hr class="svelte-1a9vj7w"/> <!--[-->`);
      for (let $$index_1 = 0, $$length = each_array_1.length; $$index_1 < $$length; $$index_1++) {
        let link = each_array_1[$$index_1];
        LinkTile($$payload2, spread_props([
          link,
          {
            origin: data.origin,
            deletePath: "?/remove",
            ondeleted: removeLink
          }
        ]));
      }
      $$payload2.out.push(`<!--]-->`);
    } else {
      $$payload2.out.push("<!--[!-->");
    }
    $$payload2.out.push(`<!--]--></section></main>`);
  }
  do {
    $$settled = true;
    $$inner_payload = copy_payload($$payload);
    $$render_inner($$inner_payload);
  } while (!$$settled);
  assign_payload($$payload, $$inner_payload);
  if ($$store_subs) unsubscribe_stores($$store_subs);
  pop();
}
export {
  _page as default
};
